import React, { createRef } from "react";
import "./App.scss";
import {
    ResultsContainer,
    SearchBoxContainer,
    FacetboxContainer,
    TopMenuContainer,
} from "./containers";
import SearchBox from "./components/searchbox/SearchBox";
import Footer from "./components/footer/Footer";
import StickyBox from "react-sticky-box";
import AppInsightsErrorBoundary from "./telemetry/TelemetryService";
import { Translation } from "react-i18next";
import { SortboxContainer } from "./containers/SortboxContainer";
import { PopupProvider } from "./contexts/popupContext";
import { ConfigProvider } from "./contexts/configContext";
import AzStoreContext, { AzStoreProvider } from "./contexts/azStoreContext";
import { OidcAuthProvider } from "./contexts/oidcAuthContext";
import AuthComponent from "./containers/AuthContainer";
import MainHeader from "./components/header/MainHeader";

interface IState {
    enableStickyComponents: boolean;
    isAnalyticsCookieAllowed: boolean;
    isCookieConsentChanged: boolean;
}

class App extends React.Component<{}, IState> {
    searchBoxRef = createRef<SearchBox>();

    isLocalhost = document.location.href.indexOf('localhost') > 0;

    constructor(props: any) {
        super(props);
        this.state = {
            enableStickyComponents: !this.isMobile(),
            isAnalyticsCookieAllowed: this.isLocalhost, // Starts with default as false, except if it's on localhost
            isCookieConsentChanged: false
        };
        this.handleResize = this.handleResize.bind(this);
    }

    isMobile() {
        return window.innerWidth <= 768;
    }

    /** Handling the window resize to remove the sticky style from elements if in a small window */
    handleResize() {
        this.setState({ enableStickyComponents: !this.isMobile() });
    }

    handleOsanoConsent() {
        if (typeof (window as any).Osano === "function") {
            let consentObject = (window as any).Osano.cm.getConsent();
            this.setState({ isAnalyticsCookieAllowed: consentObject.ANALYTICS === "ACCEPT" });

            (window as any).Osano.cm.addEventListener("osano-cm-consent-changed", () => {
                this.setState({ isCookieConsentChanged: true });
            });

            (window as any).Osano.cm.addEventListener("osano-cm-consent-saved", () => {
                if (this.state.isCookieConsentChanged)
                    window.location.reload();
            });
        }
    }

    async componentDidMount() {
        setTimeout(() => {
            this.handleOsanoConsent();
            const event = new Event("FacetsLoaded");
            window.dispatchEvent(event);
        }, 500);
    }

    resetTextBox = () => {
        if (this.searchBoxRef.current) {
            this.searchBoxRef.current.clearInput();
        }
    };

    /** Renders a result for the user when boundaries errors occured. */
    renderErrorBoundary() {
        let onClick = () => window.location.reload();

        return <div className="error-boundary">
            <h1 className="error-boundary-text"><Translation>{t => t("Something went wrong")}</Translation></h1>
            <a className="error-boundary-reload" onClick={onClick} href="#"><Translation>{t => t("Click here to reload the page")}</Translation></a>
        </div>;
    }


    renderFacetContainer() {
        if (this.state.enableStickyComponents) {
            return <StickyBox offsetTop={120} offsetBottom={20}>
                <FacetboxContainer resetAll={this.resetTextBox} />
            </StickyBox>;
        } else {
            return <FacetboxContainer resetAll={this.resetTextBox} />;
        }

    }

    render() {
        window.addEventListener('resize', this.handleResize);
        let languageFacet = this.context.azStore && this.context.azStore.getState().facets.facets["Language"];
        return (
            <ConfigProvider>
                <AppInsightsErrorBoundary onError={this.renderErrorBoundary} isActive={this.state.isAnalyticsCookieAllowed}>
                    <OidcAuthProvider>
                        <AuthComponent>
                            <AzStoreProvider>
                                <PopupProvider>
                                    <div>
                                        <div className="grid-container">
                                            <div className="top-menu">
                                                <TopMenuContainer languageFacet={languageFacet} />
                                            </div>
                                            <div className="docuware-container">
                                                <MainHeader />
                                                <hr className="seperator" />
                                            </div>
                                            <div className="masa-header">
                                                <div className="masa-header-container">
                                                    <span id="title">Marketing & Sales Tools</span>
                                                    <SearchBoxContainer ref={this.searchBoxRef} />
                                                </div>
                                            </div>
                                            <div className="facetbox">
                                                {this.renderFacetContainer()}
                                            </div>
                                            <div className="results">
                                                <SortboxContainer />
                                                <ResultsContainer />
                                            </div>
                                            <div className="footer">
                                                <Footer></Footer>
                                            </div>
                                        </div>
                                    </div>
                                </PopupProvider>
                            </AzStoreProvider>
                        </AuthComponent>
                    </OidcAuthProvider>
                </AppInsightsErrorBoundary>
            </ConfigProvider>
        );
    }
}


App.contextType = AzStoreContext;
export default App;